import { Link } from "react-router-dom";
import { TrendingUp, Building2, FileText, ArrowRight } from "lucide-react";
import { Container } from "../../components/layout/Container.jsx";
import { PageHero } from "../../components/shared/PageHero.jsx";
import { SEO } from "../../lib/seo.jsx";

const POINTS = [
  {
    icon: TrendingUp,
    title: "Yield-focused designs",
    body: "4-bedroom dual-living and dual-key configurations engineered for rental return, not just resale.",
  },
  {
    icon: Building2,
    title: "House & Land turnkey",
    body: "Pre-vetted blocks in growth corridors, paired with depreciation-friendly inclusion packages.",
  },
  {
    icon: FileText,
    title: "Investor-ready documentation",
    body: "Quantity surveyor schedules, construction progress reports, and tax depreciation reports on request.",
  },
];

export default function InvestorsPage() {
  return (
    <>
      <SEO
        title="Investors"
        description="Investor-grade builds — yield-focused designs, depreciation-ready inclusions, and a project lead per build."
      />

      <PageHero
        eyebrow="Get started"
        title="Built for investors"
        description="Builds optimised for rental yield, depreciation, and ease of ongoing management — not just first-day curb appeal."
      />

      <Container className="py-16 lg:py-20">
        <div className="grid grid-cols-1 gap-6 md:grid-cols-3">
          {POINTS.map(({ icon: Icon, title, body }) => (
            <article
              key={title}
              className="rounded-2xl border border-border-subtle bg-bg-elevated p-6"
            >
              <div className="grid h-11 w-11 place-items-center rounded-md bg-accent/15 text-accent">
                <Icon className="h-5 w-5" />
              </div>
              <h3 className="mt-4 font-display text-xl text-text-primary">{title}</h3>
              <p className="mt-2 text-sm text-text-secondary">{body}</p>
            </article>
          ))}
        </div>

        <section className="mt-16 grid grid-cols-1 gap-10 lg:grid-cols-2 lg:gap-16">
          <article className="prose-dark">
            <h2>What we offer investors</h2>
            <p>
              {
                'We work with investors and SMSF buyers on full house-and-land turnkey packages designed to be tenant-ready on day one. That means no missing fly-screens, no "landscaping later" — the whole property goes onto the rental market within a week of handover.'
              }
            </p>
            <p>
              For larger investors, we build small townhouse and dual-occupancy projects with shared
              site management, rolling site starts, and consolidated reporting.
            </p>
          </article>
          <article className="prose-dark">
            <h2>How we report</h2>
            <p>
              {
                "You'll get a fortnightly progress update with photos, a clear milestone schedule, and a single point of contact for the entire build. After handover, our maintenance team handles the warranty period directly with your property manager."
              }
            </p>
          </article>
        </section>

        <div className="mt-16 flex flex-wrap items-center justify-between gap-4 rounded-2xl border border-border-subtle bg-bg-elevated p-8">
          <div>
            <h3 className="font-display text-2xl text-text-primary">
              Want investor-specific packages?
            </h3>
            <p className="mt-1 text-sm text-text-secondary">
              Reach the investor desk for current house-and-land opportunities.
            </p>
          </div>
          <Link to="/contact-us/new-build" className="btn-primary">
            Talk to the investor desk
            <ArrowRight className="h-4 w-4" />
          </Link>
        </div>
      </Container>
    </>
  );
}
